import copy from "copy-to-clipboard";
import { useCallback, useEffect, useRef, useState } from "react";

export function useCopyToClipboard(resetDuration = 2000) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const copyText = useCallback(
    (text: string) => {
      const success = copy(text);
      if (!success) return;

      if (timerRef.current) clearTimeout(timerRef.current);
      setCopied(true);
      timerRef.current = setTimeout(() => setCopied(false), resetDuration);
    },
    [resetDuration],
  );

  return { copied, copyText };
}
